import * as types from "../types";

const initialState = {
    loading: false,
    resAuctionList: null,
    error: null
} 

export default function allAuctionListReducer(state = initialState, action){

    switch(action.type){
        case types.FETCH_ALL_AUCTION_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }

        case types.FETCH_ALL_AUCTION_LIST_SUCCESS: 
            return {
                ...state,
                loading: false,
                resAuctionList: action.payload.resAuctionList
            }

        case types.FETCH_ALL_AUCTION_LIST_FAILURE: 
            return {
                ...state,
                loading: false,
                resTableListData: null,
                error: action.payload.error
        }    

        case types.FETCH_ALL_AUCTION_LIST_RESET: 
            return {
                ...state,
                loading: false,
                resTableListData: null,
                error: null
            }  


        default : 
            return state
    }

}